import { useAuth } from '../contexts/AuthContext';

export interface Permissions {
  canViewInscripciones: boolean;
  canCargarNotas: boolean;
  canViewProfesores: boolean;
  canViewCursos: boolean;
  canViewTurnos: boolean;
  canViewAlumnos: boolean;
  canViewDashboard: boolean;
  canManageUsers: boolean;
}

export const usePermissions = (): Permissions => {
  const { user } = useAuth();

  if (!user) {
    return {
      canViewInscripciones: false,
      canCargarNotas: false,
      canViewProfesores: false,
      canViewCursos: false,
      canViewTurnos: false,
      canViewAlumnos: false,
      canViewDashboard: false,
      canManageUsers: false,
    };
  }

  const { rol } = user;

  switch (rol) {
    case 'admin':
      return {
        canViewInscripciones: true,
        canCargarNotas: true,
        canViewProfesores: true,
        canViewCursos: true,
        canViewTurnos: true,
        canViewAlumnos: true,
        canViewDashboard: true,
        canManageUsers: true,
      };

    case 'jtp':
      return {
        canViewInscripciones: true,
        canCargarNotas: true,
        canViewProfesores: true,
        canViewCursos: true,
        canViewTurnos: true,
        canViewAlumnos: true,
        canViewDashboard: true,
        canManageUsers: false,
      };

    case 'ayudante':
      return {
        canViewInscripciones: true,
        canCargarNotas: true,
        canViewProfesores: false,
        canViewCursos: false,
        canViewTurnos: false,
        canViewAlumnos: false,
        canViewDashboard: true,
        canManageUsers: false,
      };

    case 'profesor':
      return {
        canViewInscripciones: true,
        canCargarNotas: true,
        canViewProfesores: false,
        canViewCursos: false,
        canViewTurnos: false,
        canViewAlumnos: false,
        canViewDashboard: true,
        canManageUsers: false,
      };

    default:
      return {
        canViewInscripciones: false,
        canCargarNotas: false,
        canViewProfesores: false,
        canViewCursos: false,
        canViewTurnos: false,
        canViewAlumnos: false,
        canViewDashboard: false,
        canManageUsers: false,
      };
  }
};
